import { AdobeTile } from '../../types'

interface DefaultTiles {
  tiles: AdobeTile[]
  title: string
}

export const defaultTiles: DefaultTiles = {
  tiles: [
    {
      ariaText: 'Explore bank products.',
      ctaHref: '/products-and-rates/cd-products',
      ctaLabel: 'Open Account',
      description:
        'Great rates, 24/7 customer care, and a smart, simple experience on all your devices.',
      iconName: 'bank-pig',
      lobName: 'bank',
      subtitle: 'Great rates and 24/7 customer care.',
      title: 'Ally Bank',
      trackingEventName: '',
    },
    {
      ariaText: 'Explore home loan products',
      ctaHref: '/products-and-rates/buy-a-home',
      ctaLabel: 'Get Pre-qualified',
      description:
        'Our Home Team has your back every step of the way. Call us to get pre-qualified.',
      iconName: 'home-outline',
      lobName: 'mortgage',
      subtitle: 'Our Home Team has your back.',
      title: 'Ally Home Loans',
      trackingEventName: '',
    },
    {
      ariaText: 'Explore investment products.',
      ctaHref: '/products-and-rates/self-directed-trading',
      ctaLabel: 'Start Investing',
      description:
        'Low fees, 24/7 access to brokers, and real-time, streaming quotes for everyone.',
      iconName: 'line-chart',
      lobName: 'invest',
      subtitle: 'Real-time, streaming quotes for everyone.',
      title: 'Ally Invest',
      trackingEventName: '',
    },
  ],
  title: 'Explore all the ways you can grow with us.',
}
